module.exports = ".ck.ck-toolbar-dropdown .ck-toolbar{border:0}"